import React, { Component } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";

import { getAppointments, cleanAppointments } from "actions/appointments";
import { getPendingCpe } from "actions/activations";
//import { getPendingCpe } from "actions/activationsDummy"; // Import this one for fake calls (do NOT commit it!)

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Input from "components/Input";
import RadioButton from "components/RadioButton";
import Label from "components/Label";
import InlineLink from "components/InlineLink";
import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";

import consts from "consts/consts";

import style from "./style.css";
import rootStyle from "../../style.css";

@translate()
@connect((state) => ({
  isLoadingAppointments: state.appointments.user.loading,
  wsAppointmentsError: state.appointments.user.error,
  isLoadingActivations: state.activations.user.loading,
  wsActivationsError: state.activations.user.error,
}))
export default class PageIdentification extends Component {
  state = {
    error: undefined,
  };
  /** @type {string} */
  weCareIDValue = "";
  /** @type {number} */
  selectedAction = 0;

  componentWillUnmount() {
    //this.props.dispatch(cleanAppointments());
  }

  /**
   * Trigger event when the use clicks on the login button.<br />
   * Form validation + redirection based on the selected action.
   */
  onLoginClick() {
    if (!this.props.isLoadingAppointments && !this.props.isLoadingActivations) {
      const nameApp = process.env.APP_MODE;
      const { t } = this.props;

      // Reset error on WS hit
      this.setState({ error: undefined });
      nameApp === consts.mode.heyfix ? this.heyValidate(t) : this.orangeValidate(t);
    }
  }

  /**
   * Validate login screen for Hey
   * @param t
   */
  heyValidate(t) {
    if (this.weCareIDValue.length === 0) {
      this.setState({
        error: t("_HEY_LOGIN_INDEX_ERROR_REQUIRED_LOGIN"),
      });
      return;
    }

    if (this.weCareIDValue.length < 8) {
      this.setState({
        error: t("_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_SHORT_LOGIN"),
      });
      return;
    }

    if (this.weCareIDValue.length > 8) {
      this.setState({
        error: t("_HEY_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_TOO_LONG_LOGIN"),
      });
      return;
    }

    this.redirectToModifyAppointmentPage();
  }

  /**
   * Validate login screen for Orange
   * @param t
   */
  orangeValidate(t) {
    if (this.selectedAction === 0) {
      this.setState({
        error: t("_LOGIN_INDEX_ERROR_REQUIRED_ACTION"),
      });
      return;
    }

    if (this.weCareIDValue.length === 0) {
      this.setState({
        error: t("_LOGIN_INDEX_ERROR_REQUIRED_LOGIN"),
      });
      return;
    }

    if (this.weCareIDValue.length < 8) {
      this.setState({
        error: t("_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_LOGIN"),
      });
      return;
    }

    if (this.weCareIDValue.length > 8) {
      this.setState({
        error: t("_LOGIN_INDEX_ERROR_INCORRECT_LENGTH_LOGIN"),
      });
      return;
    }

    if (this.selectedAction === 1) {
      this.redirectToModifyAppointmentPage();
    } else if (this.selectedAction === 2) {
      // Activate materials
      this.redirectToActivateMaterials();
    }
  }

  redirectToModifyAppointmentPage() {
    this.props.dispatch(cleanAppointments()); // Clean previous results
    this.props.dispatch(getAppointments(this.weCareIDValue)).then((response) => {
      if (response && response.status) {
        this.props.history.push(consts.routes.appointments.url);
      }
    });
  }

  redirectToActivateMaterials() {
    this.props.dispatch(getPendingCpe(this.weCareIDValue)).then((response) => {
      if (response && response.status) {
        this.props.history.push(consts.routes.activations.url);
      }
    });
  }

  /**
   * Translate tag
   * @param {string} tag
   * @returns {*}
   */
  translate(tag) {
    const { t } = this.props;
    return t(tag);
  }

  /**
   * Triggered event when the user types his personal code (input field).
   *
   * @param {object} event
   */
  onInputChange(event) {
    this.weCareIDValue = event.target.value;
  }

  /**
   * Triggered event when the user selects his desired action (radio buttons).
   *
   * @param {object} event
   */
  onActionSelected(event) {
    this.selectedAction = parseInt(event.target.value, 0);
  }

  orangeRender() {
    const validationError = this.state.error;
    const { isLoadingAppointments, isLoadingActivations, wsAppointmentsError, wsActivationsError } = this.props;
    return (
      <Wrapper>
        <Title>
          <Trans>_LOGIN_INDEX_TITLE</Trans>
        </Title>
        <p className={style.paragraph}>
          <Trans>_LOGIN_INDEX_INTRODUCTION</Trans>
        </p>
        <p className={style.paragraph}>
          <Trans>_LOGIN_INDEX_MAIN_DESCRIPTION</Trans>
        </p>
        <Label>
          1/&nbsp;<Trans>_LOGIN_INDEX_DESIRED_ACTION</Trans>
        </Label>
        <RadioButton
          label={<Trans>_LOGIN_INDEX_ACTION_MODIFY_APPOINTMENT</Trans>}
          onClick={this.onActionSelected.bind(this)}
          isDisabled={false}
          name="desiredAction"
          id="actionAppointments"
          value={1}
          rootClassname={style.radioAction}
        />
        <RadioButton
          label={<Trans>_LOGIN_INDEX_ACTION_ACTIVATE_STB</Trans>}
          onClick={this.onActionSelected.bind(this)}
          isDisabled={false}
          name="desiredAction"
          id="actionActivations"
          value={2}
          rootClassname={style.radioAction}
        />
        <Label>
          2/&nbsp;<Trans>_LOGIN_INDEX_PERSONAL_CODE</Trans>
        </Label>
        <Input type="text" onChange={this.onInputChange.bind(this)} onSubmit={this.onLoginClick.bind(this)} />
        <Button rootClassname={style.button} onClick={this.onLoginClick.bind(this)}>
          {(isLoadingAppointments || isLoadingActivations) && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
          {!isLoadingAppointments && !isLoadingActivations && <Trans>_LOGIN_INDEX_LOGIN_BUTTON</Trans>}
        </Button>
        <p>
          <InlineLink to="/reset">
            <Trans>_LOGIN_INDEX_RESET_CODE_LINK</Trans>
          </InlineLink>
        </p>
        {validationError && <p className={style.errorMessage}>{validationError}</p>}
        {(wsAppointmentsError || (wsActivationsError && wsActivationsError.code && wsActivationsError.code === -600)) &&
          !validationError && (
            <p className={style.errorMessage}>
              <Trans>_LOGIN_INDEX_ERROR_OCCURRED</Trans>{" "}
              <InlineLink to="/reset">
                <Trans>_LOGIN_INDEX_ERROR_RESET_CODE_LINK</Trans>
              </InlineLink>{" "}
              <Trans>_LOGIN_INDEX_ERROR_CALLING_NUMBER</Trans>
            </p>
          )}
        {(wsActivationsError && wsActivationsError.code && wsActivationsError.code !== -600) &&
          !validationError && (
            <p className={style.errorMessage}>
              <Trans>_GET_PENDING_CPE_ERROR_{Math.abs(wsActivationsError.code).toString()}</Trans>
            </p>
          )}
      </Wrapper>
    );
  }

  heyRender() {
    const validationError = this.state.error;
    const { isLoadingAppointments, isLoadingActivations, wsAppointmentsError, wsActivationsError } = this.props;
    return (
      <Wrapper>
        <div className={rootStyle.fontWeightBold}>
          <Title>
            <Trans>_HEY_LOGIN_INDEX_TITLE</Trans>
          </Title>
          <p>
            <Trans>_HEY_LOGIN_INDEX_INTRODUCTION</Trans>
          </p>
          <p>
            <Trans>_HEY_LOGIN_INDEX_MAIN_DESCRIPTION</Trans>
          </p>
          <div className={[rootStyle.displayFlex, rootStyle.justifyContentCenter, rootStyle.alignItemsCenter].join(' ')}>
            <div className={[rootStyle.w100, rootStyle.displayFlex, rootStyle.justifyContentSpaceEvenly, rootStyle.alignItemsCenter].join(' ')}>
                <Input type="text" onChange={this.onInputChange.bind(this)} onSubmit={this.onLoginClick.bind(this)} placeholder={this.translate("_HEY_LOGIN_INDEX_INPUT_PLACEHOLDER")} rootClassname={rootStyle.m0} />

                <Button rootClassname={style.button} onClick={this.onLoginClick.bind(this)}>
                  {(isLoadingAppointments || isLoadingActivations) && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
                  {!isLoadingAppointments && !isLoadingActivations && <Trans>_HEY_LOGIN_INDEX_LOGIN_BUTTON</Trans>}
                </Button>
            </div>
            <div className={[rootStyle.w100, rootStyle.textAlignRight].join(' ')}>
              <p>
                <InlineLink to="/reset" rootClassname={rootStyle.textDecorationNone}>
                  <Trans>_HEY_LOGIN_INDEX_RESET_CODE_LINK</Trans>
                </InlineLink>
              </p>
            </div>
          </div>
          <div>
            {validationError && <p className={style.errorMessage}>{validationError}</p>}
            {(wsAppointmentsError || (wsActivationsError && wsActivationsError.code && wsActivationsError.code === -600)) &&
              !validationError && (
                <p className={style.errorMessage}>
                  <Trans>_HEY_LOGIN_INDEX_ERROR_OCCURRED</Trans>{" "}
                  <InlineLink to="/reset" rootClassname={rootStyle.textDecorationNone}>
                    <Trans>_HEY_LOGIN_INDEX_ERROR_RESET_CODE_LINK</Trans>
                  </InlineLink>{" "}
                </p>
              )}
            {(wsActivationsError && wsActivationsError.code && wsActivationsError.code !== -600) &&
              !validationError && (
                <p className={style.errorMessage}>
                  <Trans>_GET_PENDING_CPE_ERROR_{Math.abs(wsActivationsError.code).toString()}</Trans>
                </p>
              )}
          </div>
        </div>
      </Wrapper>
    );
  }

  renderSwitch() {
    switch (process.env.APP_MODE) {
      case consts.mode.heyfix: return this.heyRender();
      default: return this.orangeRender();
    }
  }

  render() {
    return this.renderSwitch();
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageIdentification/index.js